@if(dataLoading){
<div style="min-height: 150px;" class="d-flex justify-content-center align-items-center">
    <app-page-loader [loading]="dataLoading"></app-page-loader>
</div>
}
@else {<div class="cotainer-fluid ">
    <header class="navBar row">
        <div class="container-fluid mb-0">
            <div class="row " style="margin: 1.5rem 0.5rem 5px 0;padding: 0rem;">
                <div class="col-lg-2 pl-0 col-md-3 col-sm-12 text-center justify-content-center me-2">
                    <div class="card m-1 p-3 rounded-3" style=" height: 230px;">
                        <div (click)="openEditPatientModal()" class="edit-icon btn-warning">
                            <i class="las la-edit"></i>
                        </div>
                        <div class="card-header pt-3">
                            <img [src]="
    patientData?.gender_fk_id == 2
      ? 'assets/images/female.png'
      :  'assets/images/male.png'
  " class="img-thumbnail rounded-circle" imageLoad />

                        </div>
                        <span style="padding-top: 10px;"> <b>{{patientData?.patientName}}</b></span>
                        <span>
                            <b style="color: blue;">{{patientData?.patient_id}}</b>({{patientData?.genderName}})</span>
                        <span class="pb-3"> <b>{{patientData?.mobile_no}}</b></span>
                        <!-- <span style="padding-bottom: 15px;"> <b>{{patientData?.genderName}}</b></span> -->
                    </div>
                </div>
                <div class="col-lg-6 col-md-5 col-sm-12 card me-4 p-5 rounded-3">
                    <info-view [mapData]="patient_info" [sourceData]="patientData"></info-view>
                </div>
                <div class=" p-4 card rounded-3" style="width: 400px;">
                    <div class="text-right mr-2">
                        <div>
                            <span
                                class="float-left badge badge-primary p-2">{{patientData?.patient_categoryName}}</span>
                            <span class="mt-1" style="cursor: pointer;" (click)="whatsappMsg(patientData.mobile_no)">
                                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="30" height="30"
                                    viewBox="0 0 48 48">
                                    <path fill="#fff"
                                        d="M4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98c-0.001,0,0,0,0,0h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303z">
                                    </path>
                                    <path fill="#fff"
                                        d="M4.868,43.803c-0.132,0-0.26-0.052-0.355-0.148c-0.125-0.127-0.174-0.312-0.127-0.483l2.639-9.636c-1.636-2.906-2.499-6.206-2.497-9.556C4.532,13.238,13.273,4.5,24.014,4.5c5.21,0.002,10.105,2.031,13.784,5.713c3.679,3.683,5.704,8.577,5.702,13.781c-0.004,10.741-8.746,19.48-19.486,19.48c-3.189-0.001-6.344-0.788-9.144-2.277l-9.875,2.589C4.953,43.798,4.911,43.803,4.868,43.803z">
                                    </path>
                                    <path fill="#cfd8dc"
                                        d="M24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,4C24.014,4,24.014,4,24.014,4C12.998,4,4.032,12.962,4.027,23.979c-0.001,3.367,0.849,6.685,2.461,9.622l-2.585,9.439c-0.094,0.345,0.002,0.713,0.254,0.967c0.19,0.192,0.447,0.297,0.711,0.297c0.085,0,0.17-0.011,0.254-0.033l9.687-2.54c2.828,1.468,5.998,2.243,9.197,2.244c11.024,0,19.99-8.963,19.995-19.98c0.002-5.339-2.075-10.359-5.848-14.135C34.378,6.083,29.357,4.002,24.014,4L24.014,4z">
                                    </path>
                                    <path fill="#40c351"
                                        d="M35.176,12.832c-2.98-2.982-6.941-4.625-11.157-4.626c-8.704,0-15.783,7.076-15.787,15.774c-0.001,2.981,0.833,5.883,2.413,8.396l0.376,0.597l-1.595,5.821l5.973-1.566l0.577,0.342c2.422,1.438,5.2,2.198,8.032,2.199h0.006c8.698,0,15.777-7.077,15.78-15.776C39.795,19.778,38.156,15.814,35.176,12.832z">
                                    </path>
                                    <path fill="#fff" fill-rule="evenodd"
                                        d="M19.268,16.045c-0.355-0.79-0.729-0.806-1.068-0.82c-0.277-0.012-0.593-0.011-0.909-0.011c-0.316,0-0.83,0.119-1.265,0.594c-0.435,0.475-1.661,1.622-1.661,3.956c0,2.334,1.7,4.59,1.937,4.906c0.237,0.316,3.282,5.259,8.104,7.161c4.007,1.58,4.823,1.266,5.693,1.187c0.87-0.079,2.807-1.147,3.202-2.255c0.395-1.108,0.395-2.057,0.277-2.255c-0.119-0.198-0.435-0.316-0.909-0.554s-2.807-1.385-3.242-1.543c-0.435-0.158-0.751-0.237-1.068,0.238c-0.316,0.474-1.225,1.543-1.502,1.859c-0.277,0.317-0.554,0.357-1.028,0.119c-0.474-0.238-2.002-0.738-3.815-2.354c-1.41-1.257-2.362-2.81-2.639-3.285c-0.277-0.474-0.03-0.731,0.208-0.968c0.213-0.213,0.474-0.554,0.712-0.831c0.237-0.277,0.316-0.475,0.474-0.791c0.158-0.317,0.079-0.594-0.04-0.831C20.612,19.329,19.69,16.983,19.268,16.045z"
                                        clip-rule="evenodd"></path>
                                </svg>
                                <b style="color:red"> | Due : INR {{patientData?.total_due || 0}}</b>
                            </span>
                        </div>
                        <div class="d-flex flex-column justify-content-between" style="height: 100%;">
                            <div class="mt-4">
                                @for (m of medicalHistory; track m) {
                                @if(m) {
                                <span class="badge badge-warning m-1 p-1" style="font-size: x-small;">
                                    {{ m }}
                                </span>
                                }
                                }
                            </div>
                            <div class="mt-auto pt-1 d-flex justify-content-around align-items-center gap-2 ">
                                <!-- <button [disabled]="loading || dataLoading" (click)="confirmSubmit()" noDoubleClick
                                    class="btn btn-success ">
                                    Complete Visits
                                </button> -->
                                <!-- <button class="btn btn-info" [disabled]="loading || dataLoading" noDoubleClick
                                    (click)="genToken()">
                                    <i class="las la-scroll"></i> Get Token
                                </button>
                                <button class="btn btn-sm btn-secondary" [disabled]="loading || dataLoading"
                                    noDoubleClick (click)="printIdCard()">
                                    <i class="las la-print"></i> Card
                                </button> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </header>
    <!-- <main> -->
    <div class="row">
        <div class="col-lg-2 col-md-3 overflow-hidden sideNav" style="margin: 0rem;padding-right: 5px;">
            <tab-head #tab [styleType]="'VERTICAL'" [segment]="segment" (onSelect)="check($event)"></tab-head>
        </div>
        <div class=" col-lg-10 col-md-9 col-sm-10 mainContent ">
            <div class="card" style="height:fit-content;">
                <div class=" col-md-12 col-lg-12 mt-2">
                    <ng-container [ngTemplateOutlet]="tabBody"
                        [ngTemplateOutletContext]="{active:tab.currentSegment,visited:tab.segmentVisited}"
                        style="width: 100%;"></ng-container>
                </div>
            </div>
        </div>
        <div class="sideNavLeft" style="margin: 0rem;padding-right: 5px;">
            <!-- <ul class="list-group list-group-flush w-100 " style="width: 17.5%;padding: 0rem;">
                @for (m of segment|keyvalue:returnZero; track m) {
                <a (click)="toSelectSegment(m.value)" class="list-group-item list-group-side" style="padding: 0rem;"
                    [ngClass]="{'active': currentSegment == m.value}" [attr.tittle]="m?.value">
                    <span style="font-size: xx-small;margin: 0rem;padding: 0rem;">{{m?.value}}</span></a>
                }
                <hr class="divider" />
            </ul> -->
        </div>
    </div>
    <!-- </main> -->


    <!-- above test -->
    <ng-template #tabBody let-active="active" let-visited="visited">
        <div class="tab-pane show active" [hidden]="active != segment.SUMMARY">
            <!-- <div class="">
                <info-view class="card" [mapData]="patient_info" [sourceData]="patientData"></info-view>
            </div> -->
            <patient-summary [patientId]="patientId"></patient-summary>
            <!-- <div class="media">
                <div class="align-self-center">
                    <p>tue</p>
                    <h3>05</h3>
                    <p>2020</p>
                </div>
                <div class="media-body">
                    <div class="row">
                        <label class="label-green-bl col-3">consultation</label>
                        <p class="col-2">with Dr. Jekyll</p>
                        <p class="col-2"><i class="las la-tv"></i>on zoom</p>
                        <p class="col-2"><i class="las la-clock"></i>10.30 - 11.00</p>
                        <label class="label-cream label-sm col-2"><i class="las la-hourglass-half"></i>30
                            min</label>
                        <a class="col-1" href=""><i class="las la-ellipsis-v"></i></a>
                    </div>
                    <div class="row">
                        <label class="label-green-bl col-3">consultation</label>
                        <p class="col-2">with Dr. Jekyll</p>
                        <p class="col-2"><i class="las la-tv"></i>on zoom</p>
                        <p class="col-2"><i class="las la-clock"></i>10.30 - 11.00</p>
                        <label class="label-cream label-sm col-2"><i class="las la-hourglass-half"></i>30
                            min</label>
                        <a class="col-1" href=""><i class="las la-ellipsis-v"></i></a>
                    </div>
                </div>
            </div> -->
            <ng-container [ngTemplateOutlet]="tblTemplate"
                [ngTemplateOutletContext]="{data:virtualScrollData,column:vitrualCol}"></ng-container>
        </div>
        <div class="tab-pane show active rounded p-4 mt-3" [hidden]="active != segment.INVESTIGATION">
            <app-form-generator #investigationForm [formData]="investigationFormData"></app-form-generator>
            <div class="d-flex justify-content-center mb-3">
                <button type="button" class="btn btn-round btn-primary m-3" (click)="investigationSave()">Save</button>
            </div>
            <h6 class="my-4">History of Investigation</h6>
            <!-- <div class="row">
                <div class="col-12">
                    <patient-summary *ngIf="visited.INVESTIGATION" [patientId]="patientId"
                        type="INVESTIGATION"></patient-summary>
                </div>
            </div> -->
            <app-table-list *ngIf="visited.INVESTIGATION" [parenttblAction]="investigationTableAction"
                [parentGetList]="getListData" [tableConfig]="invesTableConfig" />
        </div>
        <div class="tab-pane show active p-4" [hidden]="active != segment.CHART">
            <app-dental-chart *ngIf="visited.CHART" [patientId]="patientId" #dentalChartRef />
            @if (visited.CHART) {
            <app-table-list [parentGetList]="getListData" [tableConfig]="chartTableConfig"
                [parenttblAction]="tblAction" />
            }
        </div>
        <div class="tab-pane show active" [hidden]="active != segment.APPOINTMENT">
            @if (visited.APPOINTMENT) {
            <div class="col-md-12 d-flex justify-content-between">
                <div class="card-title" style="padding-top: 15px;">Patient Appointment</div>
                <button type="button" class="btn btn-round btn-primary" (click)="addAppointment(patientData)"><i
                        class="las la-plus"></i>Add Appointment</button>
            </div>
            <app-table-list #tableAppointmentList [parenttblAction]="tblAction" [parentGetList]="getListData"
                [tableConfig]="appointTableConfig" />
            }
        </div>
        @if (active == segment.INVOICE) {
        <div class="tab-pane show active p-4" [hidden]="active != segment.INVOICE">
            @if (visited.INVOICE) {
            <div class="col-md-12 d-flex justify-content-between">
                <h6 class="card-title">Patient Invoice</h6>
                <!-- <button type="button" class="btn btn-round btn-info" (click)="openInvoiceModal(patientData.id)"><i
                        class="las la-plus"></i>Generate Invoice</button> -->
            </div>
            <div class="form-check form-switch mt-2">
                <input class="form-check-input" type="checkbox" id="invoiceSelectionSwitch"
                    [checked]="invoiceSelectionEnabled" (change)="toggleInvoiceSelection($event)">
                <label class="form-check-label" for="invoiceSelectionSwitch">Enable invoice selection</label>
            </div>
            <div class="pt-3">
                <!-- Old invoice table without checkbox selection kept for reference:
                <app-table-list #tableList [tableConfig]="invoiceTableConfig" [parenttblAction]="tblAction"
                    [parentGetList]="getListData" />
                -->
                <app-table-list #invoiceTableList [tableConfig]="invoiceTableConfig" [parenttblAction]="tblAction"
                    [selectable]="invoiceSelectionEnabled ? 'MULTI' : false" (onSelect)="onInvoiceSelect($event)"
                    [parentGetList]="getListData" />
            </div>
            }
        </div>
        }
        @if (active == segment.PAYMENT) {
        <div class="tab-pane show active p-4" [hidden]="active != segment.PAYMENT">
            @if (visited.PAYMENT) {
            <div class="col-md-12 d-flex justify-content-between">
                <h6 class="card-title">Patient Payment</h6>
                <button type="button" class="btn btn-round btn-primary" (click)="navigateToNewPayment()"><i
                        class="las la-plus"></i>New Payment</button>
            </div>

            <app-table-list #tableList [tableConfig]="paymentTableConfig" [parenttblAction]="tblAction"
                [parentGetList]="getListData" />
            }
        </div>
        }
        <div class="tab-pane show active p-4" [hidden]="active != segment.PRESCRIPTION">
            <div class="row">
                <div class="col-8">
                    <dynamic-table-form [showForm]="true" [showFormAfterAdd]="true" #prescriptionDynamic
                        [showFormAfterAdd]="false" [formData]="prescripFormData" />
                    <!-- <dynamic-table-form #prescriptionDynamic [formData]="prescripFormData" /> -->
                </div>
                <div class="col-4">
                    <p-listbox [options]="prescriptionTemplateData" [multiple]="true" [metaKeySelection]="false"
                        (onChange)="fillPrescriptionFromTemplate($event?.value)" optionLabel="medicine_templateName"
                        [filter]="true" [listStyle]="{'max-height': '450px'}">
                        <ng-template let-d pTemplate="item">
                            <small>{{d.medicine_templateName}}</small>
                        </ng-template>
                    </p-listbox>
                </div>
                <!-- <div class="text-left mt-2">
                    <button class="btn btn-sm btn-{{showPrescHistory ?'danger':'success'}}"
                        (click)="showPrescHistory = !showPrescHistory">
                        <i class="pi pi-{{!showPrescHistory ? 'history' : 'times'}}"></i>
                        {{!showPrescHistory ? 'History' : 'Close'}}
                    </button>
                </div> -->
            </div>
            <div class="my-4">
                <app-form-generator #prescriptionNotesForm [formData]="prescriptionNotesFormData"></app-form-generator>
            </div>
            <div class="d-flex justify-content-center my-5">
                <button type="button" class="btn btn-round btn-primary" (click)="prescriptionSave()">Save</button>
            </div>
            <div style="margin-top: 55px;">
                <h6 class="mb-4">History of Prescription</h6>
                @if (visited.PRESCRIPTION) {
                <app-table-list #prescriptionDynamic [tableConfig]="prescriptionTableConfig"
                    [parentGetList]="getListData" [parenttblAction]="prescriptionTableAction">
                </app-table-list>
                }
            </div>
            <!-- <div class="col-md-6 col-lg-6 align-center text-center mt-1 mb-1" style="max-width: 100%;"> -->
            <!-- <button noDoubleClick type="button" class="btn btn-round btn-primary pull-left"
                    (click)="prescriptionSave()">
                    <i *ngIf="loading" class="pi pi-spin pi-spinner" style="font-size: 1rem; margin-right: 10px;"></i>
                    {{loading ? 'Saving' : 'Save'}}
                </button> -->
            <!-- </div> -->
            <!-- <div class="row mt-2">
                <ng-container *ngIf="lastestPrescHistory.length; else noRecord">
                    <ng-container *ngFor="let d of lastestPrescHistory; let index = index;">
                        <div class="col-6">
                            <ng-container [ngTemplateOutlet]="prescriptionRef"
                                [ngTemplateOutletContext]="{data : d, type: 'LATEST', index: index}"></ng-container>
                        </div>
                    </ng-container>
                </ng-container>
            </div> -->
            <!-- <hr class="divider">
            <ng-container *ngIf="!patientData">
                <patient-summary [patientId]="patientId" type="PRESCRIPTION"></patient-summary>
            </ng-container> -->
            <!-- <ng-template #noRecord>
                <div class="m-3 text-center">
                    <p style="font-size: larger;">
                        <i class="text-primary las la-exclamation-triangle"></i>
                        No prescription data found...
                    </p>
                </div>
            </ng-template> -->
        </div>
        <!-- <div class="tab-pane show active" [hidden]="active != segment.FILES"> -->
        <!-- <app-multi-img-doc #imgDoc [imageData]="patientData?.doc" /> -->
        <!-- <app-form-generator #documentForm [formData]="documentFormData">
            </app-form-generator>
            <div class="col-md-6 col-lg-6 align-center text-center mt-1 " style="max-width: 100%;"> -->
        <!-- <button noDoubleClick type="button" class="btn btn-round btn-primary pull-left"
                    (click)="documentSave()">
                    <i *ngIf="loading" class="pi pi-spin pi-spinner" style="font-size: 1rem; margin-right: 10px;"></i>
                    {{loading ? 'Saving' : 'Save'}}
                </button> -->
        <!-- </div>
        </div> -->
        <!-- treatment plan -->
        <div class="tab-pane show active treatment-plan-tab p-4" [hidden]="active != segment.TREATMENT_PLAN">
            <div class="row align-items-center">
                <!-- <div class="col-md-6 col-sm-12 col-lg-6"> -->
                <app-form-generator (onChangeEvent)="treatmentSelected($event)" #treatmentPlanForm
                    [formData]="treatmentPlanFormData">
                </app-form-generator>
                <!-- </div> -->
            </div>
            <div class="d-flex justify-content-center my-3">
                <button type="button" class="btn btn-round btn-primary" (click)="treatmentPlanSave()">Save</button>
            </div>
            <div style="margin-top: 55px;">
                <h6 class="mb-4">History of Treatment Plan</h6>
                @if (visited.TREATMENT_PLAN) {
                <app-table-list #treatmentPlanTbl [tableConfig]="treatPlanTblConfig" [parentGetList]="getListData"
                    [parenttblAction]="tblAction">
                </app-table-list>
                }
            </div>
            <!-- <hr class="divider">
            <patient-summary [patientId]="patientId" type="TREATMENT_PLAN"></patient-summary> -->
        </div>

        <!-- treatment -->
        @if (active == segment.TREATMENT) {
        <div class="tab-pane show active treatment-tab p-4" [hidden]="active != segment.TREATMENT">
            <div class="row align-items-center">
                <!-- <div class="col-md-6 col-sm-12 col-lg-6"> -->
                <app-form-generator (onChangeEvent)="treatmentSelected($event)" #treatmentform
                    [formData]="treatmentFormData">
                </app-form-generator>
                <!-- </div> -->
                @if (selectedTreatmentToothNumbers.length) {
                <div class="selected-tooth-badges mt-2 mb-3">
                    <span class="selected-tooth-label">Selected Tooth</span>
                    @for (toothNumber of selectedTreatmentToothNumbers; track $index) {
                    <span class="badge badge-pill badge-success selected-tooth-badge">
                        {{toothNumber}}
                        <button type="button" class="selected-tooth-remove"
                            (click)="removeSelectedTreatmentTooth($index)"
                            [attr.aria-label]="'Remove tooth ' + toothNumber">
                            <i class="las la-times"></i>
                        </button>
                    </span>
                    }
                </div>
                }
                <div class="d-flex justify-content-center my-3">
                    <button type="button" class="btn btn-round btn-primary" (click)="treatmentSave()">Save</button>
                </div>
                <h6 class="my-4">History of Treatment</h6>
                <!-- <div class="col-sm-3 pt-md-3 col-md-3 col-lg-3 text-center">
                    @if(teethbutton){

                    <button [disabled]="!treatmentform?.isValid()" (click)="openToothModal()"
                        style="border-width: 0px;font-size: 2rem;margin-right: 2rem;"><i
                            class="las la-tooth"></i></button>
                    @if (selectedTooth.length) {
                    @for ( a of selectedTooth; track a) {
                    <span class="mr-1 badge badge-pill badge-success">{{a}}</span>
                    }
                    <button (click)="selectedTooth=[]" class="btn btn-danger btn-sm">X</button>
                    }
                    }
                </div> -->
                <!-- <div class="col-sm-3 pt-md-3 col-md-3 col-lg-3 text-center"> -->
                <!-- <button class="btn col-12 btn-success" [disabled]="addbtnShow" (click)="addTreatment()">Add</button> -->
                <!-- </div> -->
            </div>
            @if (visited.TREATMENT){
            <app-table-list #treatmentTbl [tableConfig]="treatTblConfig" [parentGetList]="getListData"
                [parenttblAction]="treatmentTableAction">
            </app-table-list>
            }
            <!-- @if(treatmentList.length!=0){
            <div style="margin-bottom: 5rem;">
                <app-form-generator #treatmentDoctor [formData]="appointFormData"></app-form-generator>
            </div>
            <div class="col-md-6 col-lg-6 align-center text-center mt-1 " style="max-width: 100%;"> -->
            <!-- <button noDoubleClick type="button" class="btn btn-round btn-primary pull-left"
                    (click)="treatmentSave()">
                    <i *ngIf="loading" class="pi pi-spin pi-spinner" style="font-size: 1rem; margin-right: 10px;"></i>
                    {{loading ? 'Saving' : 'Save'}}
                </button> -->
            <!-- </div>
            } -->
            <hr class="divider">
            <!-- <patient-summary [patientId]="patientId" type="TREATMENT"></patient-summary> -->
            <!-- <app-lazy-load-list [templateRef]="treatmentRef" [rows]="5" [parentGetList]="getTreatHistoryList" /> -->
            <!-- <div class="text-right">
                <button class="btn btn-sm btn-{{showTreatHistory ?'danger':'success'}}"
                    (click)="showTreatHistory = !showTreatHistory">
                    <i class="pi pi-{{!showTreatHistory ? 'history' : 'times'}}"></i>
                    {{!showTreatHistory ? 'History' : 'Close'}}
                </button>
            </div> -->
        </div>}
    </ng-template>
    <ng-template #tblTemplate let-column="column" let-data="data">
    </ng-template>
    <!-- <ng-template #treatmentRef let-data="data">
        <div class="card">
            <div class="row clearfix">
                <div class="col-8 mb-2">
                    <b>Dr.Admin</b>
                </div>
                <div class="col-4 mb-2 text-right p-0 pr-1">
                    <small> <b>{{'1000' | currency:'INR'}}</b></small>
                </div>
                <div class="col-7">
                    <label class="label-purple-bl label label-md w-100">Root Canal</label>
                </div>
                <div class="col-5">
                    <span class="badge mr-1 badge-pill badge-secondary">34</span>
                    <span class="badge mr-1 badge-pill badge-secondary">33</span>
                    <span class="badge mr-1 badge-pill badge-secondary">37</span>
                    <span class="badge mr-1 badge-pill badge-secondary">36</span>
                </div>
            </div>
        </div>
    </ng-template> -->

    <!-- Prescription Side Bar  -->
    <ng-template #prescriptionRef let-d="data" let-type="type">
        <div class="card">
            <div class="row clearfix">
                <div class="col-8 mb-2">
                    <b>{{d?.doctorName}}</b>
                </div>
                <div class="col-3 mb-2 text-right p-0 pr-1">
                    <small> <b>{{d?.visit_on | date:'dd-MMM-yy'}}</b></small>
                    <a href="javascript:void(0)" class="text-primary m-1" (click)="printPrescription(d)"><i
                            class="las la-print"></i></a>
                    <a *ngIf="type=='LATEST' && d?.id" href="javascript:void(0)" class="text-danger m-1"
                        (click)="deletePrescription(d?.id)"><i class="las la-trash"></i></a>
                </div>
                @for (data of d?.item ; track data) {
                <div class="col-12">
                    <label class="label-{{data?.randomColor}}-bl label label-md w-100">
                        {{data?.medicine + ' - ' + data?.duration + ' - ' + data?.dosage + ' - (' + data?.frequency +
                        ')' }}
                    </label>
                </div>
                }
            </div>
        </div>
    </ng-template>

    <!-- <p-sidebar [(visible)]="showTreatHistory" position="right">
        <app-lazy-load-list [templateRef]="treatmentRef" [parentGetList]="getTreatHistoryList" />
    </p-sidebar> -->
    <!-- <p-sidebar [(visible)]="showPrescHistory" position="right">
        <app-lazy-load-list [templateRef]="prescriptionRef" [parentGetList]="getPrescHistoryList" />
    </p-sidebar> -->
</div>}